export const TAB_NAMES = {
  Main: 'main',
  Presentation: 'presentation',
  Documents: 'documents',
  Software: 'software',
};
